import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useSubscribed = (goalUID = '') => {
  const plusSubscriptionUids = useSelector(
    ({ auth }) => auth.me?.plusSubscriptionUids || []
  );
  const isSubscribed = useMemo(
    () => plusSubscriptionUids.includes(goalUID.toUpperCase()),
    [goalUID, plusSubscriptionUids]
  );
  return isSubscribed;
};

export default useSubscribed;
